<template>
    <div :class="{bar: uploading}" class="uk-card uk-card-default uk-card-small uk-card-body uk-box-shadow-large">
        <div class="uk-flex uk-flex-between">
            <div class="uk-margin-small-right">
                <h5 class="uk-margin-remove">{{ doc["name"] }}</h5>
                <small v-for="(detail, i) in details" :key="i" class="uk-display-block uk-margin-small-top">{{ detail
                    }}</small>
            </div>
            <div>
                <label :for="id" :class="{'edoc_button_disabled': buttonDisabled}" aria-hidden="true"
                       class="uk-button uk-button-default uk-button-small" style="white-space: nowrap">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 24 24"
                         fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                         stroke-linejoin="round" class="feather feather-paperclip">
                        <path
                                d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>
                    </svg>
                    <span class="uk-visible@s">{{ $t("user_docs.attach") }}</span>
                    <input @change="onChange" :disabled="buttonDisabled" type="file" accept="image/jpeg" :id="id"
                           style="display: none">
                </label>
            </div>
        </div>
        <div v-if="totalAttached" class="uk-margin-top">
            <template v-for="(file, i) in form.files">
                <div v-if="file" :key="i" class="uk-flex uk-flex-between uk-flex-middle"
                     style="padding: 0.5rem; background-color: #dcdcdc">
                    <div class="uk-flex uk-flex-middle">
                        <span class="uk-margin-right" uk-icon="icon:image; ratio:1.5"
                              style="height: 30px; width: 30px"></span>
                        <div>
                            <span class="uk-display-block uk-text-emphasis uk-text-italic" style="white-space: nowrap">{{ $t("user_docs.page", [file.page, doc["pages"].length]) }}</span>
                            <small class="uk-display-block">{{ file.filename }}</small>
                        </div>
                    </div>
                    <div>
                        <span @click="removeAt(i)" uk-icon="close"
                              style="cursor: pointer; height: 20px; width: 20px"></span>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import UserFilesForm  from "@/utils/UserFilesForm";

    export default {
        name: "DocForm",
        props: {
            doc: { required: true, type: Object },
            clientID: { required: true, type: Number },
            id: { required: true, type: String },
        },
        data() {
            return {
                form: new UserFilesForm(this.doc.pages),
                uploading: false,
                totalAttached: 0,
                details: this.doc["details"],
                buttonDisabled: !this.doc["attachable"]
            };
        },
        methods: {
            removeAt(i) {
                this.form.removeAt(i);
                this.totalAttached = this.form.totalAttached;
            },
            onChange(e) {
                if (this.buttonDisabled) return;
                const err = this.form.setFile(
                    e.target.files[0]
                );
                e.target.value = "";
                if (err !== null) {
                    alert(Object.values(err).reduce((acc, val) => acc.concat(val)).join("\n"));
                    return;
                }
                this.totalAttached = this.form.totalAttached;
                if (!this.form.allSelected) return;
                this.form.serialize()
                    .then(data => {
                        const payload = {
                            clientID: this.clientID,
                            code: this.doc["code"],
                            apiCode: this.doc["api_code"],
                            pages: data
                        };
                        this.uploadFiles(payload);
                    })
                    .catch(err => {
                        alert(err);
                    });
            },
            uploadFiles(data) {
                if (this.buttonDisabled) return;
                this.uploading = true;
                // eslint-disable-next-line no-undef
                this.$http.post(`/upload-user-docs/${ this.user.docsetID }/`, data)
                    .then(res => {
                        this.buttonDisabled = true;
                        this.details = [this.$t("user_docs.processing")];
                        alert(res.data["res_text"]);
                    })
                    .catch(err => {
                        if (err.response.data["res_text"] !== undefined) {
                            alert(err.response.data["res_text"]);
                            return;
                        }
                        alert(this.$t("error_unexpected"));
                    })
                    .then(() => {
                        this.form.reset();
                        this.uploading = false;
                    });
            }
        },
        computed: {
            ...mapGetters(["user"]),
        }
    };
</script>

<style scoped>
    @-webkit-keyframes moving-gradient {
        0% {
            background-position: left bottom;
        }
        100% {
            background-position: right bottom;
        }
    }

    .bar {
        position: relative;
    }

    .bar:before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 5px;

        background: -webkit-linear-gradient(
                left,
                #feb50f 30%,
                #e6ff00 80%,
                #feb50f 100%
        ) repeat;

        -webkit-background-size: 50% 100%;
        -webkit-animation-name: moving-gradient;
        -webkit-animation-duration: 0.5s;
        -webkit-animation-iteration-count: infinite;
        -webkit-animation-timing-function: linear;
    }

    .edoc_button_disabled {
        background: #FFFFFF;
        color: #919191;
        border: 1px solid #c9c9c9;
        cursor: not-allowed;
    }
</style>